import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appWebsite]',
})
export class WebsiteDirective {
  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  @HostListener('focus') onFocus(): void {
    const value: string = this.el.nativeElement.value;
    if (!value || !value.startsWith('https://')) {
      this.el.nativeElement.value = `https://${value}`;
    }
    this.removeLastSlash(this.el.nativeElement);
  }

  @HostListener('blur') onBlur(): void {
    const value: string = this.el.nativeElement.value;
    if (!value || !value.startsWith('https://')) {
      this.el.nativeElement.value = `https://${value}`;
    }
    setTimeout(() => {
      this.removeLastSlash(this.el.nativeElement);
      if (this.control) {
        this.control.control?.setValue(this.el.nativeElement.value);
      }
    }, 0);
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    const value: string = this.el.nativeElement.value;

    if (value.startsWith('https://') && (value.length <= 8 || this.el.nativeElement.selectionStart < 8)) {
      const key = event.key.toLowerCase();

      if (key === 'backspace' || key === 'delete') {
        event.preventDefault();
      }

      if (key === 'x' && event.ctrlKey) {
        event.preventDefault();
        this.copyToClipboard(this.el.nativeElement);
      }
    }

    setTimeout(() => {
      this.singleHttps(this.el.nativeElement);
    }, 0);
  }

  private copyToClipboard(element: HTMLInputElement): void {
    const selectedText = element.value.substring(
      element.selectionStart ?? 0,
      element.selectionEnd ?? element.value.length,
    );
    if (selectedText) {
      navigator.clipboard.writeText(selectedText);
    }
  }

  private singleHttps(element: HTMLInputElement): void {
    const inputText = element.value;
    const matches = inputText.match(/https:\/\//g) || [];
    if (matches.length > 1) {
      element.value = inputText.replace(/https:\/\//g, (match: any, offset: any, str: string | any[]) => {
        return str.indexOf(match) === offset ? match : '';
      });
    }
  }

  private removeLastSlash(element: HTMLInputElement): void {
    const inputText = element.value;
    if (inputText.startsWith('https://') && inputText.length > 8 && inputText.endsWith('/')) {
      element.value = inputText.slice(0, -1);
    }
  }
}
